define('models/CodeModelConstructor',['core/can', 'bloodhound'], function(can, Bloodhound) {
	
	return function(json) {
		
		var db = $.parseJSON(json);
		
		function engine(searchItem){
			var searchEngine = new Bloodhound({
			    datumTokenizer: Bloodhound.tokenizers.obj.whitespace(searchItem),
			    queryTokenizer: Bloodhound.tokenizers.whitespace,
			    local: db
			});

			return searchEngine;
		};
		var engineForCode=engine('code');
		engineForCode.initialize();

		function engineForCodeWithDefault(q, sync){
			if(q === ''){
				sync(db);
			}else {
				engineForCode.get(q, function(suggestions){
					sync(suggestions);
				})
			}
		}

		// Create Reference and Collection
		var index = {}, codes = [];
		for (var i=0; i<db.length; i++) {
			index[db[i].code] = db[i];
			codes.push(db[i].code);
		}
		
		// Format Code
		// Example: "2" -> "02"
		function formatCode(code) {
			if (code === undefined) return;
			code = code.toString().toUpperCase();
			var parsed = parseInt(code, 10);
			return (code.length===1 && !isNaN(parsed)) ? '0'+code : code;
		}	
		
		function getReference(code) {
			return index[formatCode(code)];
		}
		
		return can.Model.extend({
			
			findAll: function(params) {
				return can.Deferred().resolve(this.models(codes));
			},
			
			findOne: function(code) {
				return can.Deferred().resolve(this.model(index[code]));
			},

			searchForCode: engineForCodeWithDefault,

			formatCode: formatCode
			
		},{
			
			_Title: can.compute(function() {
				var ref = getReference(this.attr('Code'));
				return ref !== undefined ? ref.title : undefined;
			}),
			
			_Description: can.compute(function() {
				var ref = getReference(this.attr('Code'));
				return ref !== undefined ? ref.description : undefined;
			}),
			
			_isValid: can.compute(function() {
				return getReference(this.attr('Code')) !== undefined;
			})
		});
	}
	
});
